// extracted by mini-css-extract-plugin
export default {"contentOuter":"notFound_contentOuter__EjsrH","imgLogo":"notFound_imgLogo__DIuCN","mainText":"notFound_mainText__5KES7","subText":"notFound_subText__1A2de"};